// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller

import { application } from "./application"



import controllers from "./**/*_controller.js"
import { Alert, Toggle } from "tailwindcss-stimulus-components"
import Dropdown from '@stimulus-components/dropdown'
import Notification from '@stimulus-components/notification'
import RevealController from '@stimulus-components/reveal'
import ContentLoader from '@stimulus-components/content-loader'
import Timeago from '@stimulus-components/timeago'
import Clipboard from '@stimulus-components/clipboard'
import Popover from '@stimulus-components/popover'
import RailsNestedForm from '@stimulus-components/rails-nested-form'
import CharacterCounter from '@stimulus-components/character-counter'


Function.prototype.throttle = function (milliseconds, context) {
    var baseFunction = this,
        lastEventTimestamp = null,
        limit = milliseconds;

    return function () {
        var self = context || this,
            args = arguments,
            now = Date.now();

        if (!lastEventTimestamp || now - lastEventTimestamp >= limit) {
            lastEventTimestamp = now;
            baseFunction.apply(self, args);
        }
    };
};

Function.prototype.debounce = function (milliseconds, context) {
    var baseFunction = this,
        timer = null,
        wait = milliseconds;

    return function () {
        var self = context || this,
            args = arguments;

        function complete() {
            baseFunction.apply(self, args);
            timer = null;
        }

        if (timer) {
            clearTimeout(timer);
        }

        timer = setTimeout(complete, wait);
    };
};

//Stimulus controller Registrations
controllers.forEach((controller) => {
    application.register(controller.name, controller.module.default);
})

application.register("dropdown", Dropdown)
application.register('alert', Alert)
application.register('toggle', Toggle)
application.register('notification', Notification)
application.register('reveal', RevealController)
application.register('content-loader', ContentLoader)
application.register('clipboard', Clipboard)
application.register('timeago', Timeago)
application.register('nested-form', RailsNestedForm)
application.register('character-counter', CharacterCounter)

application.register('popover', Popover)